import { render } from "./winBid.vue?vue&type=template&id=71d1a6e2"
import script from "./winBid.vue?vue&type=script&lang=js"
export * from "./winBid.vue?vue&type=script&lang=js"

import "./winBid.vue?vue&type=style&index=0&id=71d1a6e2&lang=scss"

import exportComponent from "/Users/a/Desktop/app/pulizhenkong_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__